<div class="right-container content-body has-max-height">
    <div class="filter-container">
        <app-upload-file
            buttonSize="default"
            class="import-btn"
            *appPermission="['Resource Import']"
            accept=".xls,.xlsx"
            [needJudgeFileType]="true"
            (selectFile)="import($event)"
        ></app-upload-file>
        <button
            class="text-btn-primary export-btn"
            nz-button
            (click)="export()"
            *appPermission="['Resource Export']"
        >
            Export
        </button>
        <app-input
            [isInputSearch]="true"
            [(value)]="menuKeyword"
            (refresh)="initMenus()"
        ></app-input>
    </div>
    <div class="menu-container">
        <ng-container *ngFor="let menu of menus">
            <div *ngIf="menu.children.length > 0" class="menu-item">
                <div class="menu-category">
                    {{ menu.category }}
                </div>

                <div class="tab-container">
                    <div
                        *ngFor="let child of menu.children;"
                        [ngClass]="tabs[pos].tab === child.tab ? 'tab-active' : ''"
                        class="tab"
                        (click)="to(child)"
                    >
                        {{ child.tab }}
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>

<app-resource-export #resourceExport (getImportResourceType)="getImportResourceType($event)"></app-resource-export>
<app-confirm-dialog
    [isVisible]="confirmVisible"
    [cancelLoading]="cancelLoading"
    [overwriteLoading]="overwriteLoading"
    [keepLoading]="keepLoading"
    [keepText]="'Keep Both'"
    [overwriteText]="'Overwrite'"
    [message]="'There are duplicated resources, how do you want save them?'"
    (submitSuccess)="fileSubmit($event)"
    (close)="close()"
></app-confirm-dialog>
